// eslint-disable-next-line
import React, { useContext, useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import "../styles/Login.css"; // Import your CSS file
import { Space } from "antd";

const Login = () => {
	const { loginUser, user } = useContext(AuthContext);
	const navigate = useNavigate();

	// Issue #88: 別タブのログインへ追従して認証状態が入っても、ログイン画面を
	// 開いたままのタブではフォームが残り続け、ヘッダーだけログイン済み表示に
	// なっていた。認証済みになったらホームへ送る（Register.js と同じ方式）。
	useEffect(() => {
		if (user) {
			navigate("/");
		}
	}, [user, navigate]);

	// Issue #69: 認証の応答を待つ間もボタンが押せたため、連打で同じ認証要求が
	// 何度も飛んでいた。
	//
	// state だけで判定すると反映が次のレンダー以降になり、同じティックで続けて
	// 押された分を弾けない。押された瞬間に同期で閉じる ref をガードにし、state は
	// ボタンの見た目（無効化と文言）専用にする。
	const submittingRef = useRef(false);
	const [submitting, setSubmitting] = useState(false);

	const handleSubmit = async (event) => {
		if (submittingRef.current) {
			// 早期 return では loginUser を通らないので、ここで送信を止める
			event.preventDefault();
			return;
		}
		submittingRef.current = true;
		setSubmitting(true);
		try {
			// loginUser は先頭で preventDefault と入力値の読み取りを済ませるため、
			// イベントをそのまま渡してよい
			await loginUser(event);
		} finally {
			submittingRef.current = false;
			setSubmitting(false);
		}
	};

	return (
		<div className="container">
			<div className="center-form">
				<div style={{ marginTop: 10, marginBottom: 10 }}>
					<Space direction="horizontal" style={{ width: "100%" }}>
						{/* <Alert
            message="If you forgot your credentials please let the admin reset your password"
            type="warning"
            closable
          /> */}
						{/* <Alert
            message="If you're having trouble logging in, try the initial password (1234) and change it later. If the issue persists, please contact the admin. [This message is due to server irregularities that have been fixed in the past 24 hours]
            "
            type="error"
          /> */}
					</Space>
				</div>
				<h1 className="center-heading">Login to your timesheet system</h1>
				<Form onSubmit={handleSubmit}>
					<Form.Group className="mb-3" controlId="formBasicEmail">
						<Form.Label>Username</Form.Label>
						<Form.Control
							type="text"
							name="username"
							placeholder="Enter Username"
						/>
					</Form.Group>

					<Form.Group className="mb-3" controlId="formBasicPassword">
						<Form.Label>Password</Form.Label>
						<Form.Control
							type="password"
							name="password"
							placeholder="Enter Password"
						/>
					</Form.Group>

					<Button
						variant="primary"
						type="submit"
						className="loginButton"
						disabled={submitting}
					>
						{submitting ? "Logging in…" : "Login"}
					</Button>
				</Form>
			</div>
		</div>
	);
};

export default Login;
